import { CircleHelp, Info } from "lucide-react";
import { useState, type ReactNode } from "react";
import { cn } from "./cn";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./shadcn/tooltip";

export type PropsDaDica = {
  /** O que a dica explica, para leitor de tela ("Como o faturamento é calculado"). */
  readonly rotulo: string;
  readonly children: ReactNode;
  /** `ajuda` (?) explica um calculo; `info` (i) explica uma legenda. */
  readonly tipo?: "ajuda" | "info";
  /** Sobre fundo escuro ou colorido, o icone usa a cor do texto. */
  readonly sobreFundo?: boolean;
  readonly className?: string | undefined;
};

/**
 * Icone pequeno que explica algo ao passar o mouse (ou tocar, no celular).
 *
 * Abre tambem no clique porque tooltip so de hover nao existe no toque: no
 * celular a explicacao simplesmente sumiria.
 */
export function Dica({ rotulo, children, tipo = "ajuda", sobreFundo = false, className }: PropsDaDica) {
  const [aberta, setAberta] = useState(false);
  const Icone = tipo === "info" ? Info : CircleHelp;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={aberta} onOpenChange={setAberta}>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={rotulo}
            onClick={(evento) => {
              evento.stopPropagation();
              setAberta((atual) => !atual);
            }}
            className={cn(
              "inline-grid size-4 shrink-0 place-items-center rounded-full align-middle transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring/50",
              sobreFundo ? "opacity-60 hover:opacity-100" : "text-muted-foreground/70 hover:text-foreground",
              className,
            )}
          >
            <Icone className="size-3.5" aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-72 px-3.5 py-2.5 text-left text-xs leading-relaxed">
          {children}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
